<div class="du-mail-popup">
    <div class="d-flex align-items-center justify-content-between du-mail-popup-header-bg">
        <div class="du-mail-popup-header d-flex align-items-center">
            <!-- <mat-icon class="back-icon" style="margin-right: 8px" (click)="closePopup()">arrow_back</mat-icon> -->
            Delete a {{ data?.entityTitle || 'Template' }}
        </div>
        <mat-icon class="du-mail-popUp-close" (click)="closePopup()">close</mat-icon>
    </div>
    <div class="du-mail-popup-container">
        <h3 style="font-family:'Poppins';">You want to delete the {{ data?.entityName || 'template' }}. All data and files in it will be lost.</h3>
        <br>
        <h3 style="font-family:'Poppins';">Are you sure you want to delete this {{ data?.entityName || 'template' }}?</h3>
        <div class="d-flex justify-content-end">
            <button class="delete-btn" (click)="confirmDelete()" mat-flat-button color="primary">
                <span>Delete</span>
            </button>
            <button class="cancel-btn gap-2" (click)="closePopup()" mat-flat-button color="secondary">
                <span>Cancel</span>
              </button>
        </div>
    </div>
</div>